import { defineClientConfig } from '@vuepress/client'
import './styles/index.css'
import './styles/navbar-override.css'  // 导航栏样式覆盖文件
import './styles/dark-mode.css'  // 暗黑模式专用样式
import './styles/enable-parent-link.css'  // 导航栏父级菜单点击功能
import JDWANavbarLogo from './components/JDWANavbarLogo.vue'

export default defineClientConfig({
  enhance({ app, router, siteData }) {
    // 适配新logo，微调样式
    if (typeof window !== 'undefined') {
      // 添加内联样式
      const style = document.createElement('style');
      style.innerHTML = `
        .navbar .logo,
        .navbar img.logo,
        .navbar a.home-link .logo {
          height: 2.6rem !important;
          min-width: 2.6rem !important;
          max-height: none !important;
          margin-right: 0.8rem !important;
          z-index: 100 !important;
        }
        
        .navbar {
          height: 4rem !important;
          line-height: 4rem !important;
          padding: 0.3rem 1.5rem !important;
        }
        
        /* 暗黑模式下反转logo颜色 */
        html.dark .navbar .logo,
        html.dark .navbar img.logo,
        html.dark .navbar a.home-link .logo {
          filter: invert(1) !important;
          -webkit-filter: invert(1) !important;
        }
      `;
      document.head.appendChild(style);
      
      // 监听暗黑模式切换
      window.addEventListener('load', () => {
        const toggleButton = document.querySelector('.toggle-color-mode-button');
        if (toggleButton) {
          toggleButton.addEventListener('click', () => {
            // 给浏览器一点时间应用暗黑模式切换
            setTimeout(() => {
              const logo = document.querySelector('.navbar .logo');
              if (logo && document.documentElement.classList.contains('dark')) {
                // 确保在暗黑模式下应用反转
                logo.style.filter = 'invert(1)';
                logo.style.webkitFilter = 'invert(1)';
              } else if (logo) {
                // 正常模式下移除反转
                logo.style.filter = '';
                logo.style.webkitFilter = '';
              }
            }, 50);
          });
        }
        
        // 处理导航栏点击问题
        setTimeout(() => {
          // 查找带有下拉菜单的导航项
          const navItems = document.querySelectorAll('.navbar .navbar-item.has-dropdown');
          navItems.forEach(item => {
            // 获取链接地址
            const link = item.querySelector('.navbar-dropdown-title');
            if (link && link.getAttribute('aria-label')) {
              const title = link.getAttribute('aria-label');
              // 提取链接地址
              let href = '';
              
              switch (title) {
                case '技术教程':
                  href = '/tutorials/';
                  break;
                case '经验分享':
                  href = '/experience/';
                  break;
                case '资源分享':
                  href = '/resources/';
                  break;
              }
              
              if (href) {
                // 创建点击事件处理函数
                link.addEventListener('click', (e) => {
                  // 检查是否点击在箭头上
                  const rect = link.getBoundingClientRect();
                  const clickX = e.clientX;
                  // 如果点击在链接文本区域内(非箭头区域)，则跳转
                  if (clickX < rect.right - 20) {
                    e.preventDefault();
                    e.stopPropagation();
                    router.push(href);
                  }
                });
              }
            }
          });
        }, 500); // 给DOM足够的加载时间
      });
    }
  },
  setup() {},
  rootComponents: []  // 移除自定义组件，因为已经不需要那么强制的样式覆盖
}) 